<template>
  <v-row justify="center">
    <v-col md="1">
        <v-sheet
          :elevation="1"
          rounded
          class="mx-auto global-stats"
          height="85"
          width="100"
        >
          <div style="margin-top: -8px">Rooms <br/> online</div>
          <div style="margin-top: 3px"><b>{{liveRooms}}</b></div>
        </v-sheet>
    </v-col>
     <v-col md="1">
        <v-sheet
          :elevation="1"
          rounded
          class="mx-auto global-stats"
          height="85"
          width="100"
        >
          <div style="margin-top: -8px">Users <br/> online</div>
          <div style="margin-top: 3px"><b>{{liveUsers}}</b></div>
        </v-sheet>
    </v-col>
    <v-col md="1">
        <v-sheet
          :elevation="1"
          rounded
          class="mx-auto global-stats"
          height="85"
          width="100"
        >
          <div style="margin-top: -8px">Rooms created</div>
          <div style="margin-top: 3px"><b>{{roomCreated}}</b></div>
        </v-sheet>
    </v-col>
    <v-col md="1">
      <v-sheet
        :elevation="1"
        rounded
        class="mx-auto global-stats"
        height="85"
        width="100"
      >
        <div style="margin-top: -8px">Rounds created</div>
        <div style="margin-top: 3px"><b>{{roundCreated}}</b></div>
      </v-sheet>
    </v-col>
    <v-col md="1">
      <v-sheet
        :elevation="1"
        rounded
        class="mx-auto global-stats"
        height="85"
        width="100"
      >
        <div style="margin-top: -8px">Votes assigned</div>
        <div style="margin-top: 3px"><b>{{votesAssigned}}</b></div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>

export default {
  data () { 
    return {
      roomCreated: 0,
      roundCreated: 0,
      votesAssigned: 0,
      liveRooms: 0,
      liveUsers: 0,
      loaded: false
    }
  },
  mounted: function() {
    fetch('https://lets-vote-server.fly.dev/stats', {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
      }
    })
    .then(response => response.json())
    .then(it => {
      this.roomCreated = it.roomCreated;
      this.roundCreated = it.roundCreated;
      this.votesAssigned = it.votesAssigned;
      this.liveRooms = it.liveRooms;
      this.liveUsers = it.liveUsers;

      this.loaded = true
    })
    .catch(console.log);
  }
}
</script>

<style scoped>

.global-stats {
  background-color: lightsteelblue;
  padding-top: 1em;
  color: 434343;
  font-size: 15px;

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>